import React, {useEffect, useState} from 'react'
import { inputTypes } from '../../../libs/react-mpk/config/constant'
import { FormWrapper } from '../../../libs/react-mpk/wrapper'
import t from 'counterpart'
import { inject, observer } from 'mobx-react'
import service from './Tarif.service'
import KodeObjekPajakService from '../KodeObjekPajak/KodeObjekPajak.service'

const TarifForm = ({envStore, match, history}) => {
  const { inputTypes, definition } = FormWrapper
  const [data, setData] = useState({loading: true, content: {}})
  const [kodeObjekPajaks, setKodeObjekPajaks] = useState([])

  const getKodeObjekPajak = async ()=> {
    var kodeObjekPajakOP = []
    const kodeObjekPajak = await KodeObjekPajakService.get()
    kodeObjekPajak.data.map((d)=> { kodeObjekPajakOP.push({ label: d.nama, value: d.id }) })
    setKodeObjekPajaks(kodeObjekPajakOP)
  }

  // initial data
  useEffect(() => {
    async function initData() {
      if(match.params.id == 'baru') {
        setData({loading: false, content: {}})
        return true
      }
      const res = await service.getOne(match.params.id)
      setData({loading: false, content:res.data})
    }
    getKodeObjekPajak()
    initData()
  }, ['match.params.id'])

  return (
    <FormWrapper
      loading={data.loading}
      actions={[
        {
          label: 'Reload',
          iconClassName: 'mdi mdi-reload'
        }
      ]}
      backTo={`/onpremise/tarif`}
      baseId="mod-form-sample"
      title={t.translate('modules.tarif.formTitle')}
      // hintMessage={t.translate('modules.form.hint.message')}
      hintShowIcon={false}
      defaultData={data.content}
      definitions={[
        // =====
        {
          inputType: inputTypes.CHECKBOX,
          label: 'Aktif',
          key: 'aktif',
          type: 'boolean',
          required: true,
        },{
          inputType: inputTypes.CHECKBOX,
          label: 'Berdasarkan Netto',
          key: 'berdasarkanNetto',
          type: 'boolean',
          required: true,
        },{
          inputType: inputTypes.INPUT,
          label: 'Jenis Tarif',
          key: 'jenisTarif',
          type: 'text',
          required: true,
        },{
          inputType: inputTypes.INPUT,
          label: 'Keterangan',
          key: 'keterangan',
          type: 'text'
        },{
          inputType: inputTypes.SELECT,
          label: 'Kode Objek Pajak ID',
          key: 'kodeObjekPajakId',
          type: 'text',
          required: true,
          options: kodeObjekPajaks
        },{
          inputType: inputTypes.CHECKBOX,
          label: 'Progresif',
          key: 'progresif',
          type: 'boolean',
          required: true,
        },{
          inputType: inputTypes.INPUT,
          label: 'Status',
          key: 'status',
          type: 'text',
          required: true,
        },{
          inputType: inputTypes.INPUT,
          label: 'Tahun Mulai Berlaku',
          key: 'tahunMulaiBerlaku',
          type: 'text',
          required: true,
          width: '50%'
        },{
          inputType: inputTypes.INPUT,
          label: 'Tahun Akhir Berlaku',
          key: 'tahunAkhirBerlaku',
          type: 'text',
          required: true,
          width: '50%'
        },{
          inputType: inputTypes.INPUT,
          label: 'Tarif DPP',
          key: 'tarifDPP',
          type: 'text',
          required: true,
          width: '50%'
        },{
          inputType: inputTypes.INPUT,
          label: 'Tarif Pajak',
          key: 'tarifPajak',
          type: 'text',
          required: true,
          width: '50%'
        },{
          inputType: inputTypes.INPUT,
          label: 'Tarif Progresif ID',
          key: 'tarifProgresifId',
          type: 'text',
          required: true,
        },{
          inputType: inputTypes.INPUT,
          label: 'Tarif Tambahan',
          key: 'tarifTambahan',
          type: 'text',
          required: true,
        },
        // -----
      ]}
      onSubmit={async (data, callback) => {
        var res = {}
        try {
          if(match.params.id == 'baru') {
            res = await service.post(data)
          } else {
            res = await service.put(data)
          }
          callback(t.translate('global.dataTelahDiSimpan'), false)
          history.push('/onpremise/tarif')
        } catch(e) {
          callback(e, true, false)
        }
      }}
    />
  )
}

export default inject('envStore')(observer(TarifForm))
